'use client';

import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';

import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';

import { setToastMessage } from '@/src/v2/store/slices/presentation/PresentationSlice';
import { useAuthContext } from '@/src/v2/layout/Auth/context/AuthContext';
import { useAppSelector } from '@/src/v2/hooks/useAppSelector/UseAppSelector';
import { useToastSelector } from '@/src/v2/store/selectors';
import Auth from '@/src/v2/layout/Auth/Auth';

const BaseLayout = () => {
  const { mode } = useAuthContext();
  const toastMessage = useAppSelector(useToastSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (toastMessage) {
      let action;
      switch (toastMessage.type) {
        case 'error':
          action = toast.error;
          break;
        case 'info':
          action = toast.info;
          break;
        case 'success':
        default:
          action = toast.success;
      }

      action(toastMessage.message);
    }
    dispatch(setToastMessage(undefined));
  }, [toastMessage]);

  return (
    <>
      {mode && <Auth />}
      <ToastContainer
        autoClose={5000}
        progressStyle={{
          background: ' var(--color-text-highlight) !important',
        }}
        limit={1}
        newestOnTop={false}
        closeOnClick={true}
        pauseOnFocusLoss={true}
        pauseOnHover={true}
        hideProgressBar={false}
        draggable={false}
        rtl={false}
        theme="dark"
        position="top-right"
        style={{ zIndex: 10000000 }}
      />
    </>
  );
};

export default BaseLayout;
